/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface InvoiceDetailSnapshot
 */
export interface InvoiceDetailSnapshot {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof InvoiceDetailSnapshot
     */
    balanceUnitDetailId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailSnapshot
     */
    debitAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailSnapshot
     */
    coveredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailSnapshot
     */
    remainingAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceDetailSnapshot
     */
    currencyDate: Date;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetailSnapshot
     */
    description: string | null;
}

/**
 * Check if a given object implements the InvoiceDetailSnapshot interface.
 */
export function instanceOfInvoiceDetailSnapshot(value: object): value is InvoiceDetailSnapshot {
    if (!('balanceUnitDetailId' in value) || value['balanceUnitDetailId'] === undefined) return false;
    if (!('debitAmount' in value) || value['debitAmount'] === undefined) return false;
    if (!('coveredAmount' in value) || value['coveredAmount'] === undefined) return false;
    if (!('remainingAmount' in value) || value['remainingAmount'] === undefined) return false;
    if (!('currencyDate' in value) || value['currencyDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function InvoiceDetailSnapshotFromJSON(json: any): InvoiceDetailSnapshot {
    return InvoiceDetailSnapshotFromJSONTyped(json, false);
}

export function InvoiceDetailSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceDetailSnapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'balanceUnitDetailId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['balanceUnitDetailId']),
        'debitAmount': json['debitAmount'],
        'coveredAmount': json['coveredAmount'],
        'remainingAmount': json['remainingAmount'],
        'currencyDate': (new Date(json['currencyDate'])),
        'description': json['description'],
    };
}

export function InvoiceDetailSnapshotToJSON(json: any): InvoiceDetailSnapshot {
    return InvoiceDetailSnapshotToJSONTyped(json, false);
}

export function InvoiceDetailSnapshotToJSONTyped(value?: InvoiceDetailSnapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balanceUnitDetailId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['balanceUnitDetailId']),
        'debitAmount': value['debitAmount'],
        'coveredAmount': value['coveredAmount'],
        'remainingAmount': value['remainingAmount'],
        'currencyDate': value['currencyDate'].toISOString().substring(0,10),
        'description': value['description'],
    };
}

